var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconArrowOutwardRounded = function SvgIconArrowOutwardRounded(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99986 5.41309C4.99986 5.82559 5.33736 6.16309 5.74986 6.16309H11.4424L4.78236 12.8231C4.48986 13.1156 4.48986 13.5881 4.78236 13.8806C5.07486 14.1731 5.54736 14.1731 5.83986 13.8806L12.4999 7.22059V12.9131C12.4999 13.3256 12.8374 13.6631 13.2499 13.6631C13.6624 13.6631 13.9999 13.3256 13.9999 12.9131V5.41309C13.9999 5.00059 13.6624 4.66309 13.2499 4.66309H5.74986C5.33736 4.66309 4.99986 5.00059 4.99986 5.41309Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowOutwardRounded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-arrow-outward-rounded.56175f78b4d87f7a1a8e39a6a4473bf4.svg";